import { useState } from 'react';

/**
 * La bandera de un pais, como IMAGEN.
 *
 * LO QUE HABIA Y POR QUE ESTABA ROTO. Se pintaban con indicadores regionales
 * Unicode -- `String.fromCodePoint(...)` sobre las dos letras del pais --, que
 * es la forma elegante y sin dependencias de dibujar una bandera... en un
 * sistema que tenga los glifos. WINDOWS NO LOS TIENE. Ahi, y es la mitad larga
 * de quien entra a este sitio, se veian las dos letras en crudo: "CL", "BR",
 * "MX". No era cuestion de fuente ni de tamaño: el glifo no existe.
 *
 * Las imagenes viven en `client/public/flags/` y las baja
 * `design/generar-banderas.mjs`; no se enlazan de una CDN ajena para no mandar
 * la IP de quien mira a un tercero.
 *
 * SI FALTA UNA, cae al codigo de dos letras dentro de un recuadro. Es lo mismo
 * que se veia antes en Windows, pero ahora es un estado deliberado y con
 * aspecto de etiqueta, no un emoji fallido. Asi un pais nuevo en el calendario
 * nunca deja un hueco raro mientras no se regenere el lote.
 */
export default function Bandera({ cc, titulo, className = '' }) {
  const [falla, setFalla] = useState(false);
  const codigo = String(cc ?? '').trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(codigo)) return null;

  /* El nombre del pais como etiqueta accesible cuando se sabe; si no, el
     codigo. Una bandera sin texto no dice nada a quien usa lector. */
  const etiqueta = titulo || codigo;

  if (falla) {
    return (
      <span className={`bandera bandera--codigo ${className}`.trim()} title={etiqueta}>
        {codigo}
      </span>
    );
  }
  return (
    <img
      className={`bandera ${className}`.trim()}
      src={`/flags/${codigo.toLowerCase()}.png`}
      width={20}
      height={15}
      alt={etiqueta}
      title={etiqueta}
      loading="lazy"
      decoding="async"
      onError={() => setFalla(true)}
    />
  );
}
